import React from "react";
import { Table } from "@/components/ui/table";
import TableHeader from "./tables/TableHeader";
import StandardTableBody from "./tables/StandardTableBody";
import { 
  isWedgingTest, 
  isBunkerTest, 
  isChippingTest, 
  isIronTest, 
  isDriverTest 
} from "../level3/scoring/utils";

interface ScoresState {
  [key: string]: (number | null)[];
}

interface LevelInfo {
  level: string;
}

interface ResultsTableProps {
  selectedTest: string | null;
  scores: ScoresState;
  testPoints: string[];
  getTestDistances: (testId: string) => Record<string, string>;
  getTableHeadTitle: () => string;
  getFormattedPoint: (point: string) => string;
  getPointTotal: (point: string) => number;
  getGrandTotal: () => number;
  levels?: Record<string, string | LevelInfo>;
}

const ResultsTable: React.FC<ResultsTableProps> = ({
  selectedTest,
  scores,
  testPoints,
  getTestDistances,
  getTableHeadTitle,
  getFormattedPoint,
  getPointTotal,
  getGrandTotal,
  levels = {}
}) => {
  const isWedging = selectedTest ? isWedgingTest(selectedTest) : false;
  const isBunker = selectedTest ? isBunkerTest(selectedTest) : false;
  const isChipping = selectedTest ? isChippingTest(selectedTest) : false;
  const isIron = selectedTest ? isIronTest(selectedTest) : false;
  const isDriver = selectedTest ? isDriverTest(selectedTest) : false;

  console.log("Level2 ResultsTable - selectedTest:", selectedTest);
  console.log("Level2 ResultsTable - testPoints:", testPoints);
  console.log("Level2 ResultsTable - isChipping:", isChipping);
  console.log("Level2 ResultsTable - isWedging:", isWedging);
  
  // For debugging
  if (selectedTest) {
    const distances = getTestDistances(selectedTest);
    console.log("Level2 ResultsTable - distances from getTestDistances:", distances);
    
    for (const point of testPoints) {
      console.log(`Level2 ResultsTable - formattedPoint for ${point}:`, getFormattedPoint(point));
    }
  }

  return (
    <div className="overflow-x-auto mt-6">
      <Table>
        <TableHeader 
          isChippingTest={isChipping}
          isSpecialPutts={false}
          getTableHeadTitle={getTableHeadTitle}
          isWedgingTest={isWedging}
          isIronTest={isIron}
        />
        
        <StandardTableBody 
          testPoints={testPoints}
          scores={scores}
          isSpecialPutts={false}
          getPointTotal={getPointTotal}
          getGrandTotal={getGrandTotal}
          getTestDistances={getTestDistances}
          selectedTest={selectedTest}
          levels={levels}
          isWedgingTest={isWedging}
          isBunkerTest={isBunker}
          isIronTest={isIron}
          isDriverTest={isDriver}
        />
      </Table>
    </div>
  );
};

export default ResultsTable;
